import { render, staticRenderFns } from "./GridListProduct.vue?vue&type=template&id=33fb12eb&scoped=true&"
import script from "./GridListProduct.vue?vue&type=script&lang=js&"
export * from "./GridListProduct.vue?vue&type=script&lang=js&"
import style0 from "./GridListProduct.vue?vue&type=style&index=0&id=33fb12eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb12eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
